export const Cautions = {
  paddingLeft: '14px',
  paddingRight: '14px',
  marginTop: '10px',
  marginBottom: '14px',
  fontFamily: 'sans-serif',
  fontSize: '10px',
  lineHeight: 1.5,
  letterSpacing: 'normal',
  color: '#808080',
}

export const VerifyResultsReasons = {
  padding: '0px 16px',
  paddingBottom: '20px',
  fontFamily: 'sans-serif',
  fontSize: '14px',
  textAlign: 'center',
  color: '#ff003d',
}

export const ListItemSectionLast = {
  borderBottom: 'none',
}

export const SubHeaderWhite = {
  backgroundColor: '#ffffff',
}

export default {
  Cautions,
  VerifyResultsReasons,
  ListItemSectionLast,
  SubHeaderWhite,
}
